// extracted by mini-css-extract-plugin
export var orderDetails = "_pk-2";
export var orderImage = "_pk-1";
export var orderMeta = "_pk-3";
export var orderSummary = "_pk-0";
export var rightArrow = "_pk-4";